import React, { useState, useEffect } from "react";
import { Box, CircularProgress, Typography, Paper } from "@mui/material";
import DashboardContainer from "../../components/dashboard-container";
import NetworkDesignViewer from "../../components/network-design/NetworkDesignViewer";
import { networkDesignService } from "../../utils/services/networkDesignService";
import { toast } from "react-toastify";

const ClientNetworkDesign = () => {
  const [designs, setDesigns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [clientId, setClientId] = useState(null);

  useEffect(() => {
    // Get client_id from localStorage
    const storedClientId = localStorage.getItem("client_id");
    if (storedClientId) {
      setClientId(storedClientId);
      fetchClientDesigns(storedClientId);
    } else {
      toast.error("Client ID not found. Please login as a client.");
      setLoading(false);
    }
  }, []);

  const fetchClientDesigns = async (clientId) => {
    try {
      const response = await networkDesignService.fetchByClient(clientId);
      setDesigns(response.data || []);
    } catch (error) {
      console.error("Error fetching client network designs:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardContainer
      header={"Network Design"}
      hideAllButton
      hideUploadButton
      hideGridList
    >
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "50vh",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <></>
      )}
      <Box sx={{ p: 2 }}>
        {designs.length === 0 ? (
          <Paper sx={{ p: 3, textAlign: "center" }}>
            <Typography variant="h6" color="textSecondary">
              No network designs found for your account.
            </Typography>
            <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
              Contact your administrator to create network designs for your
              organization.
            </Typography>
          </Paper>
        ) : (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
            {designs.map((design) => (
              <NetworkDesignViewer designId={design._id} data={design} />
            ))}
          </Box>
        )}
      </Box>
    </DashboardContainer>
  );
};

export default ClientNetworkDesign;
